import PropTypes from 'prop-types';
import React from 'react';

import './index.scss';

const CosignerSelector = ({ hasCosigner, selected, onSelectAlone, onSelectCosigner, disabled }) => {
  return (
    <div className="button-container">
      <button
        className={`button-container__yes ${selected === 'alone' ? 'selected' : ''}`}
        onClick={onSelectAlone}
        disabled={!hasCosigner || disabled}
      >
        On my own
      </button>
      <button
        className={`button-container__no with-cosigner ${
          selected === 'cosigner' ? 'selected' : ''
        }`}
        onClick={onSelectCosigner}
        disabled={!hasCosigner || disabled}
      >
        With co-signer
      </button>
    </div>
  );
};

CosignerSelector.propTypes = {
  selected: PropTypes.string.isRequired,
  onSelectAlone: PropTypes.func.isRequired,
  onSelectCosigner: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default CosignerSelector;
